import * as React from 'react'
import {
  ProductGridSectionContainer,
  ProductGridSectionTitle,
  ProductGridSectionSubtitle,
  ProductList,
  ProdutListItem,
  ProdutListItemImage,
  ProductListItemTitle,
  ProductListItemSubtitle,
  ProductListItemCaption,
  ProdutListItemImageWrapper,
  ProductExploreButton
} from './ProductGridSection.elements'

type Props = {
  title: string;
  subtitle: string;
  data: Product[];
}

interface Product {
  title: string;
  subtitle: string;
  caption?: string;
  imageUrl: string;
  isEnding?: boolean;
}

export const ProductGridSection: React.FunctionComponent<Props> = ({ title, subtitle, data }) => (
  <ProductGridSectionContainer>
    <ProductGridSectionTitle>
      {title}
    </ProductGridSectionTitle>
    <ProductGridSectionSubtitle>
      {subtitle}
    </ProductGridSectionSubtitle>
    <ProductList>
      {data.map((product: Product, i) => (
        <ProdutListItem key={i}>
          <ProdutListItemImageWrapper>
            <ProdutListItemImage src={product.imageUrl} />
          </ProdutListItemImageWrapper>
          <ProductListItemTitle>
            {product.title}
          </ProductListItemTitle>
          <ProductListItemSubtitle>
            {product.subtitle}
          </ProductListItemSubtitle>
          <ProductListItemCaption isEnding={product.isEnding}>
            {product.caption}&nbsp;
          </ProductListItemCaption>
        </ProdutListItem>
      ))}
    </ProductList>
    <ProductExploreButton>
      and more!
    </ProductExploreButton>
  </ProductGridSectionContainer>
)
